import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { WhatsAppButton } from "@/components/CtaButtons";

export default function NotFound() {
  return (
    <>
      <Seo title="Sayfa Bulunamadı | Lavenza Masaj Salonu Bursa" description="Aradığınız sayfa bulunamadı." path="/404" noindex />
      <section className="section min-h-[60vh] flex items-center bg-offwhite" data-testid="not-found-page">
        <div className="container-wide max-w-xl text-center">
          <span className="eyebrow">404</span>
          <h1 className="text-4xl sm:text-5xl font-bold text-emerald mt-3">Sayfa Bulunamadı</h1>
          <div className="section-divider my-5" />
          <p className="text-muted">Aradığınız sayfa taşınmış ya da henüz yayınlanmamış olabilir. Ana sayfaya dönebilir veya bize WhatsApp'tan yazabilirsiniz.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" className="btn btn-emerald" data-testid="not-found-home-link">Ana Sayfa</Link>
            <WhatsAppButton testId="not-found-whatsapp" />
          </div>
        </div>
      </section>
    </>
  );
}
